import { render, staticRenderFns } from "./BannerError.vue?vue&type=template&id=158e8190&"
import script from "./BannerError.vue?vue&type=script&lang=ts&"
export * from "./BannerError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports